import { Injectable,OnDestroy } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable,Subject } from "rxjs";
import { takeWhile,filter, map, mergeMap } from "rxjs/operators";
import { Router } from "@angular/router";
import { FvmsNoticeInfo } from "src/app/shared/vo/fvms.notice.info";
import { PagingInfo } from "src/app/shared/vo/fvms.paging.info";

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiNoticeService extends FvmsApiBaseService implements OnDestroy {
    subjectListNotice:Subject<FvmsNoticeInfo[]> = new Subject<FvmsNoticeInfo[]>();
    isContinue:boolean = true;

    constructor(
        public http:HttpClient
        ,private router:Router
    ) {
        super(http); 
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    getListNoticeStartUp(noticeInfo:any){
        let pagingInfo = new PagingInfo();
        this.getListNotice(noticeInfo,pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok" && response.resultValue){
                    this.subjectListNotice.next(response.resultValue);
                }
            });
    }

    getListNotice(noticeInfo:any, pagingInfo:PagingInfo):Observable<any>{
        let url = this.getApiBaseUrl() + "/notice";
        url += "/list";

        let tmpPostObject = {
            "searchInfo":noticeInfo 
            ,"pagingInfo":pagingInfo
        };


        return this.http.post<any>(url,tmpPostObject,{ headers : this.header });
    }

    updateViewCount(noticeId:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/notice";
        url += "/update/view/count";
        let noticeInfo = {
            "noticeId":noticeId
        };

        let tmpPostObject = {
            "searchInfo":noticeInfo
            ,"pagingInfo":null
        };

        let bodyData = JSON.stringify(tmpPostObject);

        return this.http.post<any>(url,bodyData,{ headers : this.header });
    }

    upsertNotice(noticeInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/notice";
        url += "/upsert";

        let tmpPostObject = {
            "searchInfo":noticeInfo
        };

        return this.http.post<any>(url,tmpPostObject,{ headers : this.header });
    }
}